import React, { lazy, Suspense } from 'react';
import DashboardLayout from 'src/layouts/dashboard';
import { AuthGuard, AdminUserGuard } from 'src/auth/guard';
import { paths } from 'src/routes/paths';
import { SplashScreen } from 'src/components/loading-screen';
import { Outlet } from 'react-router-dom';

export const Dashboard = lazy(() => import('src/pages/dashboard'));
const Instruments = lazy(() => import('src/pages/instruments'));
const Measurements = lazy(() => import('src/pages/measurements'));
const Yards = lazy(() => import('src/pages/yards'));
const Users = lazy(() => import('src/pages/users'));
const Certifications = lazy(() => import('src/pages/certifications'));
const GraphsPage = lazy(() => import('src/pages/graphs/graphs'));

const app = {
  path: '',
  element: (
    <AuthGuard>
      <AdminUserGuard>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </AdminUserGuard>
    </AuthGuard>
  ),
  children: [
    {
      path: paths.dashboard.instruments.root,
      element: (
        <DashboardLayout>
          <Instruments />
        </DashboardLayout>
      ),
    },
    {
      path: paths.dashboard.measurements.root,
      element: (
        <DashboardLayout>
          <Measurements />
        </DashboardLayout>
      ),
    },
    {
      path: paths.dashboard.yards.root,
      element: (
        <DashboardLayout>
          <Yards />
        </DashboardLayout>
      ),
    },
    {
      path: paths.dashboard.users.root,
      element: (
        <DashboardLayout>
          <Users />
        </DashboardLayout>
      ),
    },
    {
      path: paths.dashboard.certifications.root,
      element: (
        <DashboardLayout>
          <Certifications />
        </DashboardLayout>
      ),
    },
    {
      path: paths.dashboard.graphs,
      element: (
        <DashboardLayout>
          <GraphsPage />
        </DashboardLayout>
      ),
    },
  ],
};

export const appRoutes = [
  {
    path: '',
    children: [app],
  },
];
